import HttpService from "../http.services";

const apiManagementService = new HttpService(process.env.REACT_APP_API_URL);

class NotificacionesServiceGlobal {

  getNotificaciones = async (payload = {}) => {
    return await apiManagementService.post("/apiglobal/v1/getNotificaciones", payload);
  };

  contarNotificaciones = async () => {
    return await apiManagementService.post("/apiglobal/v1/contarNotificaciones", {});
  };

  marcarLeida = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/marcarNotificacionLeida", payload);
  };

  marcarTodasLeidas = async () => {
    return await apiManagementService.post("/apiglobal/v1/marcarTodasNotificacionesLeidas", {});
  };

}

const notificacionesServiceGlobalInstance = new NotificacionesServiceGlobal();

export default notificacionesServiceGlobalInstance;
